const onboardingStore = {
  namespaced: true,
  state: () => ({
    loading: false,
    step: 1,
    profile: {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      role: '',
    },
    team: {
      name: '',
      primaryPhoneNumber: '',
      primaryAddress: '',
      companyType: '',
      numberOfAgents: '',
      agentGrowthOverNextYear: '',
      supportRoles: [],
      otherValueAdds: [],
      teamFocus: [],
    },
    billing: {
      checkoutSessionId: '',
    },
  }),
  mutations: {
    setOnboardingData(state, data) {
      state.profile.firstName = data.profile.firstName;
      state.profile.lastName = data.profile.lastName;
      state.profile.phoneNumber = data.profile.phoneNumber;
      state.profile.role = data.profile.role;

      state.team.name = data.team.name;
      state.team.primaryPhoneNumber = data.team.primaryPhoneNumber;
      state.team.primaryAddress = data.team.primaryAddress;
      state.team.companyType = data.team.companyType;
      state.team.numberOfAgents = data.team.numberOfAgents;
      state.team.agentGrowthOverNextYear = data.team.agentGrowthOverNextYear;
      state.team.supportRoles = data.team.supportRoles;
      state.team.otherValueAdds = data.team.otherValueAdds;
      state.team.teamFocus = data.team.teamFocus;
    },
    setProfile(state, newProfileData) {
      state.profile = newProfileData;
    },
    setTeam(state, newTeamData) {
      state.team = newTeamData;
    },
    setProfileField(state, { key, value }) {
      state.profile[key] = value;
    },
    setTeamField(state, { key, value }) {
      state.team[key] = value;
    },
    setStep(state, step) {
      state.step = step;
    },
    setBilling(state, { checkoutSessionId }) {
      state.billing.checkoutSessionId = checkoutSessionId;
    },
  },
  actions: {
    completeOnboarding: async ({ commit, state, dispatch }, { stripeCheckoutSessionId }) => {
      commit('setBilling', { checkoutSessionId: stripeCheckoutSessionId });
      await dispatch('updateOnboardingData');

      await fetch('/api/hummer/onboarding_completion', {
        method: 'POST',
        body: JSON.stringify({ stripe_checkout_session_id: stripeCheckoutSessionId }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      });
    },
    loadOnboardingData: async ({ commit }) => {
      const res = await fetch('/api/hummer/onboarding_data');
      const { record } = await res.json();

      if (!record.data || _.isEmpty(record.data)) return;

      commit('setOnboardingData', record.data);
    },
    updateOnboardingData: async ({ commit, state }) => {
      const res = await fetch('/api/hummer/onboarding_data', {
        method: 'PUT',
        body: JSON.stringify({ onboarding_data: state }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      });

      const { record } = await res.json();

      commit('setOnboardingData', record.data);
    },
    goForward: async ({ commit, state, dispatch }) => {
      await dispatch('updateOnboardingData');
      commit('setStep', state.step + 1);
    },
  },
  getters: {
    profile: state => state.profile,
  },
};

export default onboardingStore;
